function Element({children, show}) {
  const Children = () => children

  return <>{show && <Children />}</>
}

export default Element
